// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Pokémon Universe - Warp Gates Configuration
 * 
 * Ultra Wormholes connecting the Pokémon universe to other dimensions.
 */

export const warpGates = [
  {
    id: 'gate-pokemon-milkyway',
    name: 'Ultra Wormhole Alpha',
    type: 'warpgate',
    description: 'A stable wormhole connecting to the Milky Way. Discovered by the Aether Foundation.',
    distance: 25.5, // Same as Alola Paradise - distance from starting system
    destinationUniverse: 'milkyway',
    destinationGate: 'gate_milkyway_to_pokemon',
    toSystem: 0, // Sol (Earth)
    fuelRequired: 5, // Minimum fuel % required (safety threshold only, no consumption)
    discovered: true,
    threat: 'SAFE',
    resources: 'GATEWAY',
    services: [],
    primaryColor: '#FF00FF',
    secondaryColor: '#00FFFF',
    hasRings: true,
    animated: true
  },
  {
    id: 'gate_pokemon_to_digiworld',
    name: 'Digital Evolution Portal',
    type: 'warpgate',
    description: 'A mysterious portal discovered near Kanto Prime. Digital energy signatures detected. Evolution data streams active.',
    distance: 25, // Distance from Kanto Prime
    destinationUniverse: 'digiworld',
    destinationGate: 'gate_digiworld_to_pokemon',
    toSystem: 900, // File Island
    fuelRequired: 5,
    discovered: false,
    threat: 'SAFE',
    resources: 'DIGITAL GATEWAY',
    services: [],
    primaryColor: '#00FFFF',
    secondaryColor: '#00FF00',
    hasRings: true,
    animated: true
  },
  {
    id: 'gate_pokemon_to_marioworld',
    name: 'Warp Pipe Portal',
    type: 'warpgate',
    description: 'A mysterious green pipe leads to another universe. Wahoo!',
    distance: 30, // Distance from Kanto Prime
    destinationUniverse: 'marioworld',
    destinationGate: 'gate_marioworld_to_pokemon',
    toSystem: 1000, // Mushroom Kingdom
    fuelRequired: 5,
    discovered: false,
    threat: 'SAFE',
    resources: 'WARP PIPE GATEWAY',
    services: [],
    primaryColor: '#FF0000',
    secondaryColor: '#00FF00',
    hasRings: true,
    animated: true
  }
];

// Add the Sonic Universe gate
warpGates.push({
  id: 'gate_pokemon_to_sonicuniverse',
  name: 'Speed Wormhole',
  type: 'warpgate',
  description: 'A blue portal pulses with speed energy. Pokemon meets Sonic!',
  distance: 30, // Distance from Kanto Prime
  destinationUniverse: 'sonicuniverse',
  destinationGate: 'gate_sonicuniverse_to_pokemon',
  toSystem: 2000, // Green Hill Zone
  fuelRequired: 5,
  discovered: false,
  threat: 'SAFE',
  resources: 'SPEED GATEWAY',
  services: [],
  primaryColor: '#FF0000',
  secondaryColor: '#FFFF00',
  hasRings: true,
  animated: true
});

// Warp gate positions for map visualization
// Position gates NEAR their fromSystem for easy access (within 5 LY)
export const warpGatePositions = {
  'gate-pokemon-milkyway': { x: 55, y: 76, z: 5 },      // Near Alola Paradise at (53, 74) - 2.2 LY away
  'gate_pokemon_to_digiworld': { x: 50, y: 60, z: 5 },   // Near Kanto Prime at (50, 58) - 2.0 LY away
  'gate_pokemon_to_marioworld': { x: 40, y: 55, z: 5 }   // 30 LY from Kanto Prime
};

// Add position for the new Sonic gate
warpGatePositions['gate_pokemon_to_sonicuniverse'] = { x: 35, y: 60, z: 5 }; // 30 LY from Kanto Prime
